export default function KeybindsTab() {
  return (
    <div
      style={{
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <div style={{ fontSize: 20 }}>Keybinds</div>
      <div>Hold c to collect all</div>
      <div>Press b to buy all Producers until 10</div>
      <div>Press p to Producer Strengthening (coming soon)</div>
      <div>Press s to Strengthening Boost (coming soon)</div>
      <div>Press m for Molecule Creation (coming soon)</div>
    </div>
  );
}
